// extracted by mini-css-extract-plugin
module.exports = {"modal":"LocalizationEditor_modal__36120","buttons":"LocalizationEditor_buttons__1UAgB"};